import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search"
export default class extends Controller {

  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      const url = new URL(this.element.action)
      const params = new URLSearchParams(new FormData(this.element)).toString()
      window.history.replaceState({}, "", `${url.pathname}?${params}`)

      this.element.dataset.turboScroll = "false"

      this.element.requestSubmit()
    }, 200) // small debounce
  }
}
